'use strict';

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ = require('./underscore_ext');

function permuteCaseArray(str) {
	var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

	if (i === str.length) {
		return [''];
	}
	var c = str[i],
	    u = c.toLowerCase(),
	    l = c.toUpperCase();

	return u === l ? _.flatmap(permuteCaseArray(str, i + 1), function (suffix) {
		return [[c].concat((0, _toConsumableArray3.default)(suffix))];
	}) : _.flatmap(permuteCaseArray(str, i + 1), function (suffix) {
		return [[u].concat((0, _toConsumableArray3.default)(suffix)), [l].concat((0, _toConsumableArray3.default)(suffix))];
	});
}

var permuteCase = function permuteCase(str) {
	return _.map(permuteCaseArray(_.map(str.split(''))), function (arr) {
		return arr.join('');
	});
};

var hasCase = function hasCase(s) {
	return s.toLowerCase() === s.toUpperCase() ? 0 : 1;
};

// Number of chars in str having case ('a' has case, '5' does not, so
// "a5a" returns 2, for example)
function permuteBitCount(str) {
	return _.sum(_.map(str, hasCase));
}

// prefix of str having at most n chars with case.
var prefixBitLimit = _.curry(function (n, str) {
	var counts = _.scan(str, function (count, c) {
		return hasCase(c) ? count + 1 : count;
	}, 0),
	    l = _.findLastIndex(counts, function (c) {
		return c <= n;
	});

	return str.slice(0, l);
});

module.exports = {
	prefixBitLimit: prefixBitLimit,
	permuteCase: permuteCase,
	permuteBitCount: permuteBitCount
};